import { render } from "./CostCenter.vue?vue&type=template&id=58a8fd3d&scoped=true"
import script from "./CostCenter.vue?vue&type=script&lang=js"
export * from "./CostCenter.vue?vue&type=script&lang=js"

import "./CostCenter.vue?vue&type=style&index=0&id=58a8fd3d&scoped=true&lang=css"

import exportComponent from "D:\\xampp7\\htdocs\\24x7pos\\client\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-58a8fd3d"]])

export default __exports__